import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { Meta } from '@angular/platform-browser';
import { RestApiService } from './shared/services/rest-api.service';
import { AlertService } from './shared/services/alert.service';
import { SessionService } from './shared/services/session.service';
import { MenuService } from './shared/services/menu.service';
import { RouterOutlet } from '@angular/router';
import { slideInAnimation } from './shared/interfaces/slide-in-animation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit {

  public language: string = environment.defaultLanguage;
  public loading: boolean = true;
  public loadingPage: boolean = false;

  constructor(
    private api: RestApiService,
    private alertService: AlertService,
    private translate: TranslateService,
    private metaTagService: Meta,
    public session: SessionService,
    public menu: MenuService
  ) { }

  ngOnInit() {
    this.translate.setDefaultLang(this.language);
    this.metaTagService.addTags([
      { name: 'keywords', content: `La solution d'autopartage` },
      { name: 'description', content: `VOP propose une solution d'autopartage` },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'VOP' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'date', content: '13/06/2020', scheme: 'DD/MM/YYYY' },
      { charset: 'UTF-8' }
    ]);
    this.api.setHeader('Accept', 'application/json');
    this.session.permissionsUpdated.subscribe((res) => {
      if (res === true) {
        this.loading = false;
      } else {
        this.loading = true;
      }
    });
    this.session.loadingPage.subscribe((res) => {
      if (res === true) {
        this.loadingPage = true;
      } else {
        this.loadingPage = false;
      }
    });
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

}
